// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"1aa164e9","353":"beb32cb8","605":"6ba00cf5","850":"6e6e3090"}[chunkId] + ".chunk.js";
};